import http from './http.js';

//保存评论
export function getTaskInsectPestYearList(farm_id,year){
    return http.get(`/user/task/get_task_insect_pest_year_list/`+farm_id+'/'+year)
}
export function getPestData(farm_id,area_id,year){
    return http.get(`/user/task/get_pest_data/`+farm_id+'/'+area_id+'/'+year)
}


